import type { App } from 'vue'
import type { Router } from 'vue-router'
import { ElMessage } from 'element-plus'
import { toAppError } from '@/utils/appError'

let lastMessage = ''
let lastMessageAt = 0

function showMessage(message: string) {
  const now = Date.now()
  if (message && (message !== lastMessage || now - lastMessageAt > 1000)) {
    ElMessage.error(message)
    lastMessage = message
    lastMessageAt = now
  }
}

function createErrorHandler(router: Router) {
  return (error: unknown) => {
    const appError = toAppError(error)

    if (appError.redirectTo) {
      router.push(appError.redirectTo).catch(() => undefined)
    }

    if (appError.message) {
      showMessage(appError.message)
    }
  }
}

export function installGlobalErrorHandler(app: App, router: Router) {
  const handleError = createErrorHandler(router)

  app.config.errorHandler = (error) => {
    handleError(error)
  }

  window.addEventListener('unhandledrejection', (event) => {
    handleError(event.reason)
  })
}
